var _excluded = ["cancelButtonText", "commentIncluded", "commentPlaceholder", "commentRequired", "commentSubtitle", "highRatingText", "isOpen", "lowRatingText", "modalTitle", "onCancel", "onSubmit", "pleaseWaitButtonText", "ratingIncluded", "ratingRequired", "ratingSubtitle", "submitButtonText"];

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useEffect, useState } from 'react';
import { usePrevious } from 'react-use';
import Button from "../../Button/Button";
import ButtonToolbar from "../../Button/ButtonToolbar";
import Modal from "../../Modal/Modal";
import ModalBody from "../../Modal/ModalBody";
import ModalFooter from "../../Modal/ModalFooter";
import ModalHeader from "../../Modal/ModalHeader";
import FeedbackModalBody from "./FeedbackModalBody";

var FeedbackModal = function FeedbackModal(props) {
  var cancelButtonText = props.cancelButtonText,
      commentIncluded = props.commentIncluded,
      commentPlaceholder = props.commentPlaceholder,
      commentRequired = props.commentRequired,
      commentSubtitle = props.commentSubtitle,
      highRatingText = props.highRatingText,
      isOpen = props.isOpen,
      lowRatingText = props.lowRatingText,
      modalTitle = props.modalTitle,
      onCancel = props.onCancel,
      onSubmit = props.onSubmit,
      pleaseWaitButtonText = props.pleaseWaitButtonText,
      ratingIncluded = props.ratingIncluded,
      ratingRequired = props.ratingRequired,
      ratingSubtitle = props.ratingSubtitle,
      submitButtonText = props.submitButtonText,
      otherProps = _objectWithoutProperties(props, _excluded);

  var wasOpen = usePrevious(isOpen);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      rating = _useState2[0],
      setRating = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      comment = _useState4[0],
      setComment = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      submitting = _useState6[0],
      setSubmitting = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      ratingValidationError = _useState8[0],
      setRatingValidationError = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      commentValidationError = _useState10[0],
      setCommentValidationError = _useState10[1];

  useEffect(function () {
    if (wasOpen && !isOpen) {
      setRatingValidationError(null);
      setCommentValidationError(null);
      setSubmitting(false);
    }
  }, [isOpen, wasOpen]);

  var cancel = function cancel() {
    onCancel();
    setRating(null);
    setComment(null);
  };

  var submit = function submit() {
    var error = false;
    var commentErrorMessage = null;
    var ratingErrorMessage = null;

    if (!rating && ratingRequired) {
      ratingErrorMessage = "can't be blank";
      error = true;
    }

    if (!comment && commentRequired) {
      commentErrorMessage = "can't be blank";
      error = true;
    }

    setRatingValidationError(ratingErrorMessage);
    setCommentValidationError(commentErrorMessage);

    if (error) {
      return;
    }

    setSubmitting(true);
    onSubmit({
      rating: rating,
      comment: comment
    });
  };

  return /*#__PURE__*/React.createElement(Modal, _extends({
    isOpen: isOpen,
    toggle: cancel
  }, otherProps), /*#__PURE__*/React.createElement(ModalHeader, {
    toggle: cancel
  }, modalTitle), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(FeedbackModalBody, {
    highRatingText: highRatingText,
    lowRatingText: lowRatingText,
    commentIncluded: commentIncluded,
    commentPlaceholder: commentPlaceholder,
    commentRequired: commentRequired,
    commentSubtitle: commentSubtitle,
    commentValidationError: commentValidationError,
    ratingIncluded: ratingIncluded,
    ratingRequired: ratingRequired,
    ratingSubtitle: ratingSubtitle,
    ratingValidationError: ratingValidationError,
    setRating: setRating,
    setComment: setComment
  })), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(ButtonToolbar, null, /*#__PURE__*/React.createElement(Button, {
    disabled: submitting,
    color: "primary",
    onClick: submit
  }, submitting ? pleaseWaitButtonText : submitButtonText), /*#__PURE__*/React.createElement(Button, {
    disabled: submitting,
    onClick: cancel
  }, cancelButtonText))));
};

FeedbackModal.displayName = "FeedbackModal";
export default FeedbackModal;